import _createForOfIteratorHelper from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default {
  data: function data() {
    return {
      appListAllData: [],
      appLoginTypeConfigDataNoPage: [],
      appLoginTypeRes: [],
      appPaymentTypeAllData: [],
      appGatewayChannelListAllData: [],
      appRealnameAuthConfigTypeDataAll: [],
      appIAATypeAllData: [],
      showStatus: [{
        lable: '显示',
        value: 1
      }, {
        lable: '不显示',
        value: 2
      }]
    };
  },
  activated: function activated() {
    var _this = this;

    if (this.$route.params.user_id) {
      this.$nextTick(function () {
        _this.paramsData.appid = _this.$route.params.appid;
        _this.paramsData.user_id = _this.$route.params.user_id;

        _this.getList();

        _this.$route.params.appid = '';
        _this.$route.params.user_id = '';
      });
    }
  },
  methods: {
    getcommonData: function getcommonData() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqList, _iterator, _step, i, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                _iterator = _createForOfIteratorHelper(reqList);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 12;
                  break;
                }

                i = _step.value;
                _context.next = 8;
                return _this2.$api[i]();

              case 8:
                data = _context.sent;
                _this2[i] = data.data;

              case 10:
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 17:
                _context.prev = 17;

                _iterator.f();

                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14, 17, 20]]);
      }))();
    },
    // 根据游戏ID获取登录类型
    getLoginType: function getLoginType(id) {
      var _this3 = this;

      this.paramsData.o_type = '';
      this.$api.appLoginTypeConfigDataNoPage({
        appid: id,
        isMustAppid: 2
      }).then(function (res) {
        if (res.status == 200) {
          _this3.appLoginTypeConfigDataNoPage = res.data;
        }
      });
    }
  }
};